import * as Yup from 'yup';

export function useValidationSchema() {
  return Yup.object().shape({
    lastNDays: Yup.number().nullable().required(),
  });
}
